import { BsStopwatch } from "react-icons/bs";
import { FormattedMessage } from "react-intl";
import { OverviewPanelWrapper } from "../../components/OverviewPanelWrapper";
import { ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { TOperationHoursCounter } from "./types";
import { themedUseStyletron } from "../../../theme/customTheme";


export function OverviewPanel(props: TOperationHoursCounter) {
    const [css,theme] = themedUseStyletron()
    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} icon={<BsStopwatch size="100%"></BsStopwatch>} {...props}>
            <ValueDisplayWithLabel label={<FormattedMessage id="Devices.OperatingHours" defaultMessage="Operating Hours" />} dimension={"h"} value={props.value}></ValueDisplayWithLabel>
        </OverviewPanelWrapper>
    );
}